/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Seasonal_ContentInputs */

const en_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Tree Collection`)
};

const ar_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجموعة اشجار متنوعة من بلس`)
};

const de_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Baumkollektion`)
};

const es_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colección de árboles Plus`)
};

const fr_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collection d'arbres Plus`)
};

const it_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collezione alberi Plus`)
};

const ja_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plusツリーコレクション`)
};

const ko_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 나무 컬렉션`)
};

const pt_br_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coleção de árvores Plus`)
};

const ru_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коллекция деревьев Plus`)
};

const th_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คอลเล็กชันต้นไม้สำหรับ Plus`)
};

const tr_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus Mevsimsel İçerikPlus Ağaç Koleksiyonu`)
};

const zh_cn_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 树种阵容`)
};

const zh_tw_subscription_seasonal_content = /** @type {(inputs: Subscription_Seasonal_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus 樹種陣容`)
};

/**
* | output |
* | --- |
* | "Plus Tree Collection" |
*
* @param {Subscription_Seasonal_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_seasonal_content = /** @type {((inputs?: Subscription_Seasonal_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Seasonal_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_seasonal_content(inputs)
	if (locale === "ar") return ar_subscription_seasonal_content(inputs)
	if (locale === "de") return de_subscription_seasonal_content(inputs)
	if (locale === "es") return es_subscription_seasonal_content(inputs)
	if (locale === "fr") return fr_subscription_seasonal_content(inputs)
	if (locale === "it") return it_subscription_seasonal_content(inputs)
	if (locale === "ja") return ja_subscription_seasonal_content(inputs)
	if (locale === "ko") return ko_subscription_seasonal_content(inputs)
	if (locale === "pt_br") return pt_br_subscription_seasonal_content(inputs)
	if (locale === "ru") return ru_subscription_seasonal_content(inputs)
	if (locale === "th") return th_subscription_seasonal_content(inputs)
	if (locale === "tr") return tr_subscription_seasonal_content(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_seasonal_content(inputs)
	return zh_tw_subscription_seasonal_content(inputs)
});